import Init from '../../../extendable/Init';
import PageHeader from '../../../components/PageHeader/PageHeader';
import Join from '../../../components/Join/Join';
import Gallery from '../../../components/Gallery/Gallery';
import DownloadFiles from '../../../components/DownloadFiles/DownloadFiles';

import './SingleArticle.scss';

const SingleArticle = () => {
};

Init(SingleArticle);
